document.addEventListener('DOMContentLoaded', function () {
  const discountOptions = document.querySelectorAll('.volume-discount-option');
  const quantityInput = document.querySelector('input[name="quantity"]');

  discountOptions.forEach(option => {
    option.addEventListener('click', function () {
      // Remove active class from all options
      discountOptions.forEach(opt => opt.classList.remove('active'));

      // Add active class to the selected option
      this.classList.add('active');

      // Update the quantity input
      const selectedQuantity = this.getAttribute('data-quantity');
      if (quantityInput) {
        quantityInput.value = selectedQuantity;
      }
    });
  });
});